import * as React from "react";

import "./DataLoad.scss";

import {
    Grid,
    Typography,
    LinearProgress,
    Tooltip,
    IconButton
} from '@material-ui/core';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Rest from "src/services/Rest";

// tslint:disable-next-line:no-empty-interface
export interface IDataLoadBookstoreProps {
    group: any,
    handleOpenDialogDetailDays(bs : any): void
}

// tslint:disable-next-line:no-empty-interface
export interface IDataLoadBookstoreState {
    bookstores: any[],
    loading: boolean,
}

export class DataLoadBookstore extends React.Component<IDataLoadBookstoreProps, IDataLoadBookstoreState> {

    constructor(props: IDataLoadBookstoreProps) {
        super(props);

        this.state = {
            bookstores: [],
            loading: false
        }
        this.sendRequestBookstoresByGroup = this.sendRequestBookstoresByGroup.bind(this);
    }

    public componentDidMount() {
        this.sendRequestBookstoresByGroup();
    }
    
    public render() {

        return (
            <Grid item={true} xs={12}>
                {
                    this.state.loading ? 
                        <LinearProgress /> : 
                        this.state.bookstores && this.state.bookstores.length > 0 ? 
                            this.state.bookstores.map((bs:any, bsKey: number) => {
                                return (
                                    <Grid container={true} direction="row" spacing={16} key={bsKey} className='bookstoreInfo'>
                                        <Grid item={true} xs={1}  />
                                        <Grid item={true} xs={2}>
                                            <Typography>{bs.cnpj}</Typography>
                                        </Grid>
                                        <Grid item={true} xs={3}>
                                            <Typography>{bs.bs_name}</Typography>
                                        </Grid>
                                        <Grid item={true} xs={2}>
                                            <Typography>{bs.min_day}</Typography>
                                        </Grid>
                                        <Grid item={true} xs={2}>
                                            <Typography>{bs.max_day}</Typography>
                                        </Grid>
                                        <Grid item={true} xs={1}>
                                            <Tooltip title="Ver detalhes">
                                                <IconButton className="viewAction" color="primary" onClick={this.props.handleOpenDialogDetailDays.bind(this, bs)} aria-label="Ver detalhes">
                                                    <VisibilityIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </Grid>
                                        <Grid item={true} xs={1} />
                                    </Grid>
                                )
                            }) : null
                }
            </Grid>
        );
    }
    
    private sendRequestBookstoresByGroup () {
        const groupId = this.props.group.grp_id;
        if(!this.state.loading) {
            this.setState({ loading: true });
            const path = 'dataLoad/'+groupId+'/bookstores';
            Rest.GET(path, null)
                .then(response => response.json())
                .then((result:any) => {
                    if(result != null && result !== undefined && result.length > 0) {
                        this.setState({ bookstores: result, loading: false });
                    } else {
                        this.setState({ bookstores: [], loading: false });
                    }
                });
        }
    }

}



// WEBPACK FOOTER //
// ./src/component/administration/data-load/DataLoadBookstore.tsx